import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Address } from '@classes/address';
import { Client } from '@classes/client';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { Site } from '@classes/site';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { AddressesService } from '@services/addresses.service';
import { ArticlesService } from '@services/articles.service';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { UiService } from '@services/ui.service';

@Component({
  selector: 'app-article-create',
  templateUrl: './article-create.component.html',
  styleUrls: ['./article-create.component.scss'],
})
export class ArticleCreateComponent
  extends FormEditBaseComponent
  implements OnInit
{
  senders: Address[];
  steps: Address[];
  urgencies: DictionaryValue[];

  @Input() site: Site;
  @Input() client: Client;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private addressesSrv: AddressesService,
    private articlesSrv: ArticlesService,
    private dictinaryValuesSrv: DictionaryValuesService,
  ) {
    super(uiSrv, fb);
  }

  ngOnInit(): void {
    this.initSub();
  }

  initSub() {
    const addressPromise = new Promise((resolve, reject) => {
      this.addressesSrv.getList().subscribe((addressessFromSrv) => {
        this.senders = addressessFromSrv.filter((address) => address.isSender);
        this.steps = addressessFromSrv.filter((address) => address.isReceiver);
        resolve(true);
      });
    });

    const urgenciesPromise = new Promise((resolve, reject) => {
      this.dictinaryValuesSrv
        .getUrgencyListById2(this.client.id)
        .subscribe((urgenciesFromSrv) => {
          this.urgencies = urgenciesFromSrv;
          resolve(true);
        });
    });

    Promise.all([addressPromise, urgenciesPromise]).then(() => {
      this.isLoading = false;
      this.initForm();
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      sender: this.fb.group(
        {
          address: [null, [Validators.required]],
          otherAddress: [null],
        },
        Validators.required,
      ),
      urgency: [null, Validators.required],
      steps: this.fb.array([], Validators.required),
    });
  }

  onAddReceiver(): void {
    const newGroup = this.fb.group({
      address: [null, [Validators.required]],
      daysWeekDayPrice: [],
      daysWeekNightPrice: [],
      saturdayDayPrice: [],
      saturdayNightPrice: [],
      sundayDayPrice: [],
      sundayNightPrice: [],
    });

    this.getArray('steps').push(newGroup);
  }

  onRemoveReceiver(index: number): void {
    this.getArray('steps').removeAt(index);
  }

  private create(): void {
    let formValues = this.editForm.value;
    if (typeof formValues.sender.address === 'string') {
      formValues.sender.otherAddress = formValues.sender.address;
      formValues.sender.address = null;
    } else {
      formValues.sender.otherAddress = null;
    }

    let stepAddressIds = [];
    let allTariffs = [];

    formValues.steps.map((step) => {
      let stepTariffs = [];
      let tariffDaysWeek = {
        dayPrice: step.daysWeekDayPrice,
        days: [1, 2, 3, 4, 5],
        nightPrice: step.daysWeekNightPrice,
      };

      let tariffSaturday = {
        dayPrice: step.saturdayDayPrice,
        days: [6],
        nightPrice: step.saturdayNightPrice,
      };

      let tariffSunday = {
        dayPrice: step.sundayDayPrice,
        days: [0],
        nightPrice: step.sundayNightPrice,
      };

      let tariffVacation = {
        dayPrice: step.sundayDayPrice,
        days: [],
        nightPrice: step.sundayNightPrice,
      };

      stepAddressIds.push(step.address.id);
      stepTariffs.push(
        tariffDaysWeek,
        tariffSaturday,
        tariffSunday,
        tariffVacation,
      );

      allTariffs.push(stepTariffs);
    });

    let newArticle = {
      siteId: this.site.id,
      senderAddressId: formValues.sender.address.id,
      stepAddressIds: stepAddressIds,
      urgencyId: formValues.urgency.id,
    };

    this.articlesSrv.post(newArticle).subscribe((articleFromSrv) => {
      articleFromSrv.steps.map((oneStep, indexStep) => {
        this.articlesSrv
          .putStepArticle(
            articleFromSrv.id,
            oneStep.id,
            allTariffs[indexStep],
            this.client.isSubcontractor,
          )
          .subscribe(() => {
            if (indexStep === articleFromSrv.steps.length - 1) {
              this.isLoading = false;
            }
          });
      });
    });
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.create();
    } else {
      this.onCancel();
    }
  }
}
